import {asyncActionGenerator, plainActionGenerator} from 'utils';

export const fetchTrailerAsyncActions = asyncActionGenerator('FETCH_TRAILER')
export const playTrailerAsyncActions = asyncActionGenerator('PLAY_TRAILER')
export const actionButtonAsyncActions = asyncActionGenerator('ACTION_BUTTON_TRAILER')
export const createSessionAsyncActions = asyncActionGenerator('CREATE_SESSION')
export const videoEndedAsyncActions = asyncActionGenerator('VIDEO_ENDED')
export const endTimeUpdateAsyncActions = asyncActionGenerator('END_TIME_UPDATE')